<template>
  <van-swipe-cell :disabled="disableSwipe">
    <div class="item-main"
      @click="showDetail(data.id)">
      <div class="item-img">
        <van-image :src="data.logo" />
      </div>
      <div class="item-info">
        <div class="item-head">
          <div class="head-name"
            v-text="data.name"></div>
          <div class="item-stage"
            v-text="data.stageName"></div>
        </div>
        <div class="tags"
          style="padding-top: 22px;">
          <van-tag v-for="item in data.industries"
            :key="item.id"
            plain
            type="primary"
            class="my-tag">
            {{ item }}
          </van-tag>
        </div>
        <div class="div-chk"
          v-show="showChk">
          <van-checkbox v-model="data.checked"
            checked-color="#c52a1a"></van-checkbox>
        </div>
      </div>
    </div>
    <template #right>
      <div class="cell-right"
        @click="cancelMark(data.id)">
        &nbsp;&nbsp; 取消收藏&nbsp;&nbsp;
      </div>
    </template>
  </van-swipe-cell>
</template>

<script>
import {
  Dialog
} from 'vant';
export default {
  name: "",
  data () {
    return {};
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showChk: {
      type: Boolean,
      required: false,
    },
    disableSwipe: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  computed: {
    showPreferences () {
      let res = "";
      let prefresArr = this.data.investmentPreferences;
      if (prefresArr) {
        prefresArr.forEach((element) => {
          res += element.name + ",";
        });
      }
      return res;
    },
  },
  components: {},
  mounted () { },
  created () {
    this.data.industries = _.split(this.data.favoriteField, ',', 4);
  },
  methods: {
    cancelMark (id) {
      Dialog.confirm({
        title: "提示",
        message: "确认取消收藏该机构",
      })
        .then(() => {
          //request
          this.$emit("cancel", id);
        })
        .catch(() => {
          // on cancel
        });
    },
    showDetail (id) {
      // this.$router.push({ name: "orgDetail", params: { orgId: id } });
      // this.$router.push({ path: "/orgDetail/"+id} );
      if (!this.showChk) {
        this.$router.push({
          path: "/orgDetail/" + Math.random() * 1000000,
          query: {
            id: id,
          },
          //   meta: {
          //     keepAlive: false
          //   }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.item-main {
  display: flex;
  padding: 0.375rem;
  border-bottom: 1px solid #f2f2f2;
  .item-img {
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0.25rem;
  }
  .item-info {
    padding: 0.25rem;
    flex: 1;
    position: relative;
    .item-head {
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      .head-name {
        color: #2d2d2d;
        font-size: 14px;
        font-weight: bolder; //width: 70%;
      }
      .item-stage {
        color: #f27b16;
        font-size: 12px;
      }
      .head-flag {
        flex: 1;
        background-color: #fffaee;
        text-align: center;
        color: #d04a02;
      }
    }
    .item-prefer {
      padding: 0.5rem 0;
      color: #7d7d7d;
      font-size: 0.75rem;
      .prefer-detail {
        word-break: break-all;
      }
    }
    .tags {
      .my-tag {
        background-color: #f7f7f7;
        color: rgb(131, 131, 131);
        padding: 0.25rem;
        font-size: 0.75rem;
        margin: 0 0.25rem 0 0;
      }
      .my-tag::before {
        border: none;
      }
    }
    .div-chk {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.cell-right {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  // background-color: #7d7d7d;
  color: #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/OrgItem.vue